<template>
  <!-- 添加SEO组件 -->
  <SeoMetaInfo
    :title="seoTitle"
    :description="seoDescription"
    :keywords="seoKeywords"
  />
  <div class="app-container">
    <a-config-provider
      :locale="zhCN"
      :theme="theme"
      :auto-insert-space-in-button="false"
    >
      <div
        v-if="!$route.meta.isHiddLayout"
        :class="['app-header', isHomePage ? '' : 'app-header-no-home']"
      >
        <Header />
      </div>
      <div class="app-content">
        <router-view />
      </div>
      <GameDetailFooter v-if="$route.meta.showGameDetailFooter" />
      <Footer v-if="!$route.meta.isHiddFooter" />

      <CustomerService v-if="!$route.meta.isHiddLayout" />
    </a-config-provider>
    <!-- <LoginRegModal /> -->
    <RealNameModal />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import zhCN from "ant-design-vue/es/locale/zh_CN";
// import LoginRegModal from "@components/LoginRegModal.vue";
import SeoMetaInfo from "@components/SeoMetaInfo.vue";
import Header from "@components/Header.vue";
import Footer from "@components/Footer.vue";
import CustomerService from "@components/CustomerService.vue";
import GameDetailFooter from "@/components/GameDetailFooter.vue";
import RealNameModal from './components/RealNameModal.vue';

const route = useRoute();
const isHomePage = computed(() => route.path === "/");
const theme = {
  token: {
    colorPrimary: "#ff942e", // 主题色（橙色）
    colorSuccess: "#52c41a",
    colorWarning: "#faad14",
    colorPrimaryHover: "#ff942e",
    colorPrimaryActive: "#ff942e",
    colorLinkHover: "#ff942e",
    colorLinkActive: "#ff942e",
    colorError: "#f5222d",
    colorLink: "#ff942e",
  },
};
</script>

<style>
@font-face {
  font-family: "PingFangSC-medium";
  src: local("PingFang SC Medium"), local("PingFang SC"), local("PingFangSC-Medium");
  font-display: swap;
}
@font-face {
  font-family: "PingFangSC-regular";
  src: local("PingFang SC"), local("PingFangSC-Regular");
  font-display: swap;
}
@font-face {
  font-family: "DingTalk-JinBuTi";
  src: url("./assets/font/DingTalk-JinBuTi.ttf") format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "AlimamaShuHeiTi-Bold";
  src: url("./assets/font/AlimamaShuHeiTi-Bold.ttf") format("truetype");
  font-display: swap;
}
/* 全局样式 */
body,
html {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}
body {
  overflow-y: scroll;
}
.app-container {
  min-height: 100vh;
  font-family: "PingFangSC-medium";
  background-color: #f9f9f9;
  position: relative;
}
.app-header {
  position: fixed;
  top: 0;
  width: 100%;
  height: 80px;
  background-color: rgba(251, 251, 251, 0.9);
  z-index: 9;
}
.app-header-no-home {
  background-color: #ffffff;
}
</style>
